import React from "react";
import { StyledBannerBorder, useDashedBannerStyles } from "../style";

const DashedBanner = () => {
  const styles = useDashedBannerStyles();
  return (
    <div className={styles.bannerDashed}>
      <StyledBannerBorder />
      <StyledBannerBorder />
      <StyledBannerBorder />
    </div>
  );
};

export default DashedBanner;
